import { cn } from '@brew/ui/cn'
import type { ReactNode } from 'react'

/**
 * The framed box a full email sits in on the detail surfaces — the template
 * page's single email and every email on a flow page's stage — so the two
 * read as the same object. Server-safe.
 */
export function EmailFrame({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'rounded-lg bg-muted/50 p-4 shadow-2xl shadow-black/10 dark:shadow-black/40',
        className
      )}
    >
      {children}
    </div>
  )
}
